import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button, message, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { getLogoUploadUrl, uploadLogo } from '../../../utils/api';
import { IMAGE_CONTENT_TYPES } from '../../../consts';

const LogoModalContent = ({ data, close }) => {
  const [fileSelected, setFileSelected] = useState(null);
  const [imageUrlSelected, setImageUrlSelected] = useState(null);

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const uploadImage = async (options) => {
    const { onSuccess, onError, file, onProgress } = options;
    try {
      setFileSelected(file);
      getBase64(file, (url) => {
        setImageUrlSelected(url);
      });
      const extension = file.name.split('.').at(-1);
      const type = IMAGE_CONTENT_TYPES[extension];
      const res = await getLogoUploadUrl(data.id, extension, type);
      const cloudUrl = res.data.data.url;

      const cloudRes = await axios.put(cloudUrl, file, {
        headers: {
          'Content-Type': file.type,
        },
      });

      onProgress({ percent: 100 });
      const updateServer = await uploadLogo(data.id, {
        file_name: res.data.data.filename,
      });
      if (updateServer) {
        onSuccess('Ok');
      }
      message.success('Successfully uploaded file!');
      setTimeout(close, 500);
    } catch (err) {
      console.log({ err });
      message.error('Error uploading file!');
      onError({ err });
    }
  };

  return (
    <div className='flex justify-center '>
      <Upload
        name='avatar'
        type='.svg,.png,.jpg,.jpeg'
        onRemove={() => {
          setFileSelected(null);
          setImageUrlSelected(null);
        }}
        maxCount={1}
        customRequest={uploadImage}
      >
        <Button icon={<UploadOutlined />}>Click to Upload</Button>
        {imageUrlSelected ? (
          <img
            src={imageUrlSelected}
            alt='avatar'
            style={{
              width: '100%',
            }}
          />
        ) : null}
      </Upload>
    </div>
  );
};

export default LogoModalContent;
